/**
 * 앱 `login` 라우트의 `loadComponent` 로 쓰는 지연 로더.
 *
 * ```ts
 * { path: 'login', loadComponent: loadSpinoffLoginRoute }
 * ```
 *
 * 로그인 컴포넌트(`SpinoffLoginComponent`)는 barrel(`index.ts`)로 export 하지 않는다 — barrel 에서 재export 하면 번들러가 정적으로
 * 끌어 들여 앱 초기 번들에 로그인 폼·phone-input·libphonenumber 가 함께 실린다(`index.exports.spec.ts`). 앱은 이 로더로만 쓴다.
 */
export function loadSpinoffLoginRoute(): Promise<typeof import('./spinoff-login-page.component').SpinoffLoginPageComponent> {
  return import('./spinoff-login-page.component').then((m) => m.SpinoffLoginPageComponent);
}
